import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from './components/Landing';
import GaleriaSwiper from './components/GaleriaSwiper';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import DeleteAccount from './components/DeleteAccount';
import RedirectPlayStore from './components/Download';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/demo" element={<GaleriaSwiper />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/download" element={<RedirectPlayStore />} />

    </Routes>
  );
}

export default App;
